import React, { Component } from 'react';

import './Home.css';

import { homeBanner, logo, copernicus } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Footer from '../../components/Footer/Footer';
import routes from '../../utils/routes';
import { API_URL } from '../../utils/config';

interface Props {
    history?: any,
}
interface State { }

class Home extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
    }
    render() {
        return (
            <>
                <Page
                    footer={<Footer />}
                    id="home"
                    banner={{
                        bannerImage: homeBanner,
                        big: true,
                        customTitle:
                            <>
                                <div className="banner-logos">
                                    <a id="logo_sentinel" href="https://sentinel.esa.int/web/sentinel/user-guides/sentinel-2-msi" target="_black">
                                        <img className="" src={logo} alt="logo" />
                                    </a>
                                    <a id="logo_copernicus" href="https://www.copernicus.eu/en" target="_black">
                                        <img className="" src={copernicus} alt="copernicus" />
                                    </a>
                                </div>
                                <div className="home-banner">
                                    <div className="home-banner-title">
                                        <br />
                                        <br />
                                        <br />
                                        <div className="home-banner-title-main">
                                            Sentinel-2 Anomaly Database
                                        </div>
                                    </div>
                                </div>
                            </>
                        ,
                        topBar: {
                            routes: routes,
                            disableLogo: true
                        }
                    }}
                >
                    <div className="page-content">
                        <div className="centered-content padding">
                            <div className="home-page-text">

                                <br />
                                
                                <p>
                                    The Sentinel-2 on-line anomaly database provides a searchable access to the list of known anomalies on Sentinel-2
                                    products. This database includes both on-board anomalies (usually irrecoverable) and processing anomalies
                                    (potentially recoverable), and covers image data as well as metadata and format anomalies. For each anomaly, a short
                                    description and illustrations are provided and a list of datatakes, datastrips or products can be retrieved.
                                    <br />
                                    <br />
                                    In addition to the search interface, this website provides an API (Application Programming Interface)
                                    for machine-to-machine access using scripts.
                                    <br />
                                    <br />

                                    The API provides the following services:
                                </p>
                                <ul>
                                    <li>Get all anomalies: <a href={`${API_URL}/api/v1/anomalies/`} target="_black">Example</a></li>
                                    <li>Get anomaly by id: <a href={`${API_URL}/api/v1/anomalies/1`} target="_black">Example</a></li>
                                </ul>

                                <br />

                                <p>
                                    For each anomaly the following information is provided:
                                </p>
                                <ul>
                                    <li>Anomaly sequential identifier (also used in the Data Quality Report)</li>
                                    <li>Anomaly title</li>
                                    <li>Type: on-board anomalies are generally irrecoverable. Processing anomalies can occur at different level (L0, L1C, L2A). Downstream products are impacted by anomalies at lower level. For instance, an L0 processing anomaly affects L1C and L2A products.</li>
                                    <li>Category: a systematic anomaly occurs on a well-defined set of products. A recurrent anomaly occurs from time to time in the production.</li>
                                    <li>Creation and update dates of the anomaly description file</li>
                                    <li>The impact list provides a set of impacted products. The list may be exhaustive (complete list of affected products) or partial (example of affected products).</li>
                                    <li>Illustrations are provided for some anomalies</li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </Page>
            </>
        );
    }

};


export default Home;
